var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVerifiedNew = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  color: "#00BC9A",
  viewBox: "0 0 18 18"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.394 1.24C3.48 5.545.932 1.065.932 6.48c0 7.55 5.735 9.829 7.462 10.115 1.721-.286 7.463-2.565 7.463-10.115 0-5.414-2.548-.934-7.463-5.24z",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.78.538L8.394 0l.615.538c1.695 1.486 2.768 1.828 4.792 1.96 2.236.148 2.988.982 2.988 3.982 0 3.639-1.245 6.457-3.38 8.461-1.52 1.427-3.424 2.334-4.862 2.574l-.152.025-.153-.025c-1.44-.24-3.344-1.146-4.865-2.574C1.243 12.937 0 10.119 0 6.48c0-3 .752-3.835 2.988-3.982 2.024-.133 3.096-.475 4.792-1.96zm1.394 12.08l2.607-6.391h-1.482l-1.866 4.79-1.865-4.79H5.072l2.607 6.391h1.495z",
  fill: "currentColor",
  fillRule: "nonzero"
}))));
export default SvgVerifiedNew;